<template>
	<div class="hris-page">
		<div class="hris-page-inner">
			<div class="hris-page-header">
				<span class="hris-page-eyebrow">Database Management</span>
				<h1 class="hris-page-title">Database Management</h1>
				<p class="hris-page-subtitle">Track ongoing database maintenance tasks.</p>
			</div>

			<div class="hris-panel">
				<div class="hris-panel-title">Ongoing</div>
				<div class="hris-empty">No ongoing tasks at the moment.</div>
			</div>
		</div>
	</div>
</template>



<script>
	import axios from 'axios';
	import mixins from '../../mixins';


	export default {


		data() {
			return {
				data:[],
				message: "hello world",
				showMessage: true,
				deleteDialog: false,
				publishModel: [],
				id: '',
				isPub:'',
				fullMsg: '',
				pub: [],
				nPub: []

			}
		},

		created(){
			this.eventHub.$on('readMoreAnnouncement', this.displayData);
			//this.displayData();
		},

		methods: {

		}
	};

</script>
